import { NeutralColor } from "node-library/dist/colors";
import { FrontendContentPage } from "node-library/dist/constants";
import {
	FrontendCompanyWithAdditionalInfomation,
	FrontendUserInfo,
} from "node-library/dist/portal";
import { FrontendSampleTestBatchOverview } from "node-library/dist/structures/frontendSampleTestBatchPageDefinitions";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AdminViewBatchTableListView from "./adminViewBatchTableListView";

interface Props {
	company: FrontendCompanyWithAdditionalInfomation;

	batchOverviews: Array<FrontendSampleTestBatchOverview>;
	user: FrontendUserInfo | undefined;
	// sortBy: OrderTableSortColumn;
	// setSortBy: React.Dispatch<React.SetStateAction<OrderTableSortColumn>>;
	// sortOrder: SortOrder;
	// setSortOrder: React.Dispatch<React.SetStateAction<SortOrder>>;
	navigateToOrderDetailsPage: (
		orderId: string,
		fromPage: FrontendContentPage
	) => void;
	navigateToBatchDetailsPage: (
		batchId: string,
		fromPage: FrontendContentPage
	) => void;
}

export default function AdminViewBatchContent(props: Props) {
	const { t: translation } = useTranslation();

	const {
		company,
		batchOverviews,
		// sortBy,
		// setSortBy,
		// sortOrder,
		// setSortOrder,
		navigateToOrderDetailsPage,
		navigateToBatchDetailsPage,
	} = props;

	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < 600);
		};

		// Set the initial screen size on mount
		handleResize();

		// Listen for window resize
		window.addEventListener("resize", handleResize);

		// Clean up the event listener
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	return (
		<div style={{ flex: "1 1 0%", position: "relative" }}>
			{batchOverviews.length === 0 ? (
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						position: "absolute",
						left: "50%",
						top: "50%",
						transform: "translate(-50%, -50%)",
						gap: "5px",
					}}
				>
					<div className="no-order-icon"></div>

					<div
						className="typography-body-01 typography-bold"
						style={{ marginTop: "20px" }}
					>
						{translation("NoBatches")}
					</div>
					<div
						className="typography-body-02"
						style={{ color: NeutralColor.NEUTRAL_GREY_500 }}
					>
						{translation("NoBatchesDescription")}
					</div>
				</div>
			) : (
				// isMobile ? (
				// 	// <AdminViewOrdersTableGridView
				// 	// 	orders={orders}
				// 	// 	user={props.user}
				// 	// 	deleteOrder={deleteOrder}
				// 	// 	viewOrderCOC={viewOrderCOC}
				// 	// 	goToViewOrderDetails={goToViewOrderDetails}
				// 	// 	setDiscardOrderConfirmOpen={setDiscardOrderConfirmOpen}
				// 	// 	setProceedAction={setProceedAction}
				// 	// />
				// 	<></>
				// ) : (
				// 	<AdminViewBatchTableListView
				// 		company={company}
				// 		batchOverviews={batchOverviews}
				// 		user={props.user}
				// 		navigateToOrderDetailsPage={navigateToOrderDetailsPage}
				// 		navigateToBatchDetailsPage={navigateToBatchDetailsPage}
				// 	/>
				// )

				<AdminViewBatchTableListView
					company={company}
					batchOverviews={batchOverviews}
					user={props.user}
					navigateToOrderDetailsPage={navigateToOrderDetailsPage}
					navigateToBatchDetailsPage={navigateToBatchDetailsPage}
				/>
			)}
		</div>
	);
}
